import PopupDialog from "./index.vue";

export default PopupDialog;
